import React from 'react';
import CustomCarousel from '../../../components/mazraeKit/customCarousel';
import UserCard from '../../../components/mazraeKit/cards/userCard';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import BreadcrumbCusTom from '../../../components/mazraeKit/customBreadcrumb';
import BackTitleHeader from '../../../components/mazraeKit/headers/backTitleHeader';

const CustomersPointOfView = () => {
  return (
    <div className="flex flex-col w-full h-full gap-4">
      <BackTitleHeader title="دیدگاه مشتریان" />
      <div className="flex flex-col w-full overflow-y-auto gap-4">
        <CustomCarousel
          data={images.map(item => {
            return {image: item, link: '', isExternal: false};
          })}
        />{' '}
        <div className="flex w-full px-4">
          <BreadcrumbCusTom items={BreadcrumbItems} />
        </div>
        <h5 className="flex w-full px-4 text-gray-800 text-md">
          علفکش گلایفوزیت ۱۲ درصد
        </h5>
        <div className="flex w-full px-4 justify-between items-center">
          <span className="text-md text-gray-700">قیمت:</span>
          <span className="text-xl">{(45000).toLocaleString()} تومان</span>
        </div>
        <div className="w-full flex items-center gap-6 flex-col px-4">
          {listButton.map((item, index) => (
            <UserCard
              cardWrapperClassName="!w-full"
              rate={3.5}
              key={index}
              timeDate={'۲۳‌ مهر ۱۴۰۲'}
              description="بسیار بد. خداوند لعنتتان کند."
              name="نام فروشگاه"
            />
          ))}
        </div>
      </div>
      <MainFooter />
    </div>
  );
};

export default CustomersPointOfView;
const images = [
  'https://s3.ir-thr-at1.arvanstorage.ir/market-post-images/entity_files/1%20-%20Copy%20%282%29_330.jpg?AWSAccessKeyId=0416b31d-76f2-4701-bafb-d074d31eb6a6&Signature=8VvDGMpEwLLt%2FabYcWX70ITDGUA%3D&Expires=1712989748',
  'https://s3.ir-thr-at1.arvanstorage.ir/market-post-images/entity_files/images_128.jpg?AWSAccessKeyId=0416b31d-76f2-4701-bafb-d074d31eb6a6&Signature=NDlfJe%2FK%2F5nVtI84UNp%2By2JrYbA%3D&Expires=1712993846',
];
const listButton = [1, 2, 3, 4, 5, 6, 7, 8];
interface IItem {
  label: string;
  url: string;
}
const BreadcrumbItems: Array<IItem> = [
  {
    label: 'sdf',
    url: 'sdf',
  },
];
